import { forwardRef } from "react";
import { WiAlien, WiSmog } from "react-icons/wi";
import { GiCarWheel } from "react-icons/gi";
import "../style.css";

const AlienTruck = forwardRef(
  ({ item, carrier, confirmSelection, move, setMove, selected }, ref) => (
    <div
      className={`${
        "iconRegular" in item && "iconRegular" in carrier && "enter"
      } ${
        selected && "leave"
      } mb-10 self-center text-xl font-bold flex flex-row place-content-center w-full`}
    >
      {("iconRegular" in item || "iconRegular" in carrier) &&
        !("iconRegular" in item && "iconRegular" in carrier) && (
          <div className="self-center flex flex-row place-content-center relative w-24 h-24">
            <div className="absolute top-2">{item?.iconRegular}</div>
            <div className="absolute bottom-2">{carrier?.iconRegular}</div>
          </div>
        )}

      {"iconRegular" in item && "iconRegular" in carrier && (
        <div className="flex flex-row relative">
          <button
            ref={ref}
            onClick={confirmSelection}
            className="self-center fill-slate-700 outline-none focus:fill-blue-900 hover:fill-blue-900"
          >
            <div className="self-center flex flex-row place-content-center relative w-96 h-64">
              <div className="absolute top-3 left-24">{item?.iconRegular}</div>
              <div className="absolute top-5 left-20">
                {carrier?.iconRegular}
              </div>
              <div className="absolute right-40 top-5">
                <WiAlien className="text-6xl text-[#48fb47]" />
              </div>
              <svg
                viewBox="0 0 640 512"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
                className="text-[400px] stroke-[5px] stroke-white z-30"
              >
                <path d="M624 224h-16v-64c0-17.67-14.33-32-32-32h-73.6L419.22 24.02A64.025 64.025 0 0 0 369.24 0H256c-17.67 0-32 14.33-32 32v96H48c-8.84 0-16 7.16-16 16v80H16c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h16.72c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64h65.45c29.21-38.65 75.1-64 127.28-64s98.07 25.35 127.28 64H624c8.84 0 16-7.16 16-16v-32c0-8.84-7.16-16-16-16zm-336-96V64h81.24l51.2 64H288zm304 224h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 512 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0l-22.63 22.63c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67A110.85 110.85 0 0 0 373.2 352H368c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32c-.02-8.84-7.18-16-16.02-16zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48zm-208-80h-5.2c-2.2-7.33-5.07-14.28-8.65-20.89l3.67-3.67c6.25-6.25 6.25-16.38 0-22.63l-22.63-22.63c-6.25-6.25-16.38-6.25-22.63 0l-3.67 3.67A110.85 110.85 0 0 0 192 277.2V272c0-8.84-7.16-16-16-16h-32c-8.84 0-16 7.16-16 16v5.2c-7.33 2.2-14.28 5.07-20.89 8.65l-3.67-3.67c-6.25-6.25-16.38-6.25-22.63 0L58.18 304.8c-6.25 6.25-6.25 16.38 0 22.63l3.67 3.67a110.85 110.85 0 0 0-8.65 20.89H48c-8.84 0-16 7.16-16 16v32c0 8.84 7.16 16 16 16h5.2c2.2 7.33 5.07 14.28 8.65 20.89l-3.67 3.67c-6.25 6.25-6.25 16.38 0 22.63l22.63 22.63c6.25 6.25 16.38 6.25 22.63 0l3.67-3.67c6.61 3.57 13.57 6.45 20.9 8.65v5.2c0 8.84 7.16 16 16 16h32c8.84 0 16-7.16 16-16v-5.2c7.33-2.2 14.28-5.07 20.9-8.65l3.67 3.67c6.25 6.25 16.38 6.25 22.63 0l22.63-22.63c6.25-6.25 6.25-16.38 0-22.63l-3.67-3.67a110.85 110.85 0 0 0 8.65-20.89h5.2c8.84 0 16-7.16 16-16v-32C288 359.16 280.84 352 272 352zm-112 80c-26.51 0-48-21.49-48-48s21.49-48 48-48 48 21.49 48 48-21.49 48-48 48z" />
              </svg>
            </div>
            <div
              className={`absolute ml-1 text-8xl bottom-4 right-16 text-[#d0ddbf] bg-black rounded-full ${
                move && "animate-spin"
              }`}
            >
              <GiCarWheel />
            </div>
            <div
              className={`absolute ml-2 text-8xl bottom-4 left-14 text-[#d0ddbf] bg-black rounded-full ${
                move && "animate-spin"
              }`}
            >
              <GiCarWheel />
            </div>
            <div className="z-40 absolute ml-1 text-xs top-20 right-40 font-black bg-yellow-200 rounded-full p-1">
              Let's Go!
            </div>
          </button>
          <div className="absolute bottom-20 left-0">
            <WiSmog className="text-5xl text-slate-500 -rotate-90 animate-pulse" />
          </div>
        </div>
      )}
    </div>
  )
);
export default AlienTruck;
